import React from 'react'
import { IncompleteProfile } from '../../../../context/types'
import { Link } from 'react-router-dom'
import { SortOrder } from 'antd/lib/table/interface'
import { Checkbox, Tooltip } from 'antd'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const columns = [
	{
		title: 'Expert',
		dataIndex: 'username',
		key: 'username',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: string, v: IncompleteProfile) => {
			return (
				<span>
					<Link to={`/expert/${v.slug}`} target="_blank">{`${v.username}`}</Link>
				</span>
			)
		},
	},
	{
		title: 'Email',
		dataIndex: 'user.email',
		key: 'email',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: string, v: IncompleteProfile) => {
			return (
				<p style={{ display: 'flex', flexDirection: 'column' }}>
					<span>
						<a href={`mailto:${v.email}`}>{v.email}</a>
					</span>
				</p>
			)
		},
	},
	{
		title: 'Brand',
		dataIndex: 'brand_name',
		key: 'brand_name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: string, v: IncompleteProfile) => {
			return <span>{v.brand_name}</span>
		},
	},
	{
		title: 'Picture',
		dataIndex: 'profile_pic_url',
		key: 'profile_pic_url',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: string, v: IncompleteProfile) => {
			return <Checkbox disabled checked={Boolean(v.profile_pic_url)} />
		},
	},
	{
		title: 'Availability',
		dataIndex: 'cronofy_filled',
		key: 'cronofy_filled',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: boolean, v: IncompleteProfile) => {
			return <Checkbox disabled checked={Boolean(v.cronofy_filled)} />
		},
	},
	{
		title: 'Pay Rate',
		dataIndex: 'is_pay_rate_valid',
		key: 'is_pay_rate_valid',
		render: (_: boolean, v: IncompleteProfile) => {
			return <Checkbox disabled checked={Boolean(v.is_pay_rate_valid)} />
		},
	},
	{
		title: 'Expert Page',
		dataIndex: 'expert_pages_status',
		key: 'expert_pages_status',
		render: (_: boolean, v: IncompleteProfile) => {
			const length = v.expert_pages_status.length
			return v.expert_pages_status?.map((page, index) => (
				<span key={page.channel}>
					{page.channel}
					{!page.completed ? (
						<Tooltip title="Incomplete expert page data in current channel">
							<FontAwesomeIcon icon={faExclamationTriangle} color="#e2c716" />
						</Tooltip>
					) : null}
					{index < length - 1 ? ', ' : null}
				</span>
			))
		},
	},
]
